<template>
  <div class="about">
    <LayoutTitle :msg="contestName" ></LayoutTitle>
    <LayoutContent
      :tableData="tableData"
      :showResult="showResult"
      :loading="loading"
      :rank="rank">
    </LayoutContent>
  </div>
</template>

<script>
import LayoutTitle from '@/components/LayoutTitle.vue'
import LayoutContent from '@/components/LayoutContent.vue'

export default {
  name: 'About',
  components: {
    LayoutTitle,
    LayoutContent
  },
  props:{
    gameType: String,
    contestName: String,
  },
  data(){
    return{
      /* debug loading:false */
      loading: true,
      showResult: this.gameType != "Mahjong" ? true : false,  // 預設麻將不顯示結果
      timeOutRefresh: null,
      rank: [],
      tableData: [
        {
          ID: 1,
          Name: 'player 1',
          Connect: false,
          Rounds: [
            {
              Opponent: [
                {
                  ID: null,
                  Name: null
                },
              ],
              Games: [
                {
                  Order: null,
                  Result: null,
                  Score: null
                },
                {
                  Order: null,
                  Result: null,
                  Score: null
                },
              ],
            }
          ]
        }
      ],
    }
  },
  methods:{
    getData(url) {
      console.log(url);
      this.loading = true;
      fetch(url, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          "key": "Content-Type",
          "value": "application/json",
          "description": ""
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, cors, *same-origin
        //redirect: 'follow', // manual, *follow, error
        //referrer: 'no-referrer', // *client, no-referrer
      }).then(response => response.json()).then(response => {
        this.tableData = response.Players;
        this.loading = false;
      }).catch(error => {
        console.log(error);
      });
    },
    cleanTimeOut() {
      window.clearInterval(this.timeOutRefresh);
    },
    setTimeoutRefresh() {
      this.timeOutRefresh = window.setInterval(() => {
        const server_url = "http://120.126.151.216:5555";
        this.getData(`${server_url}/Contest/Detail?gameType=${this.gameType}&contestName=${this.contestName}`, "GET");
        console.log('Refresh data');
      }, 1000 * 60 );
    },
  },
  mounted(){
    /* debug 需註解 */
    const server_url = "http://120.126.151.216:5555";
    this.getData(`${server_url}/Contest/Detail?gameType=${this.gameType}&contestName=${this.contestName}`, "GET");
    this.setTimeoutRefresh();
  }
}
</script>